/**
 * Identifies which CSF surface a Dynamic Commissioning (DC) Add-to-Basket
 * event originated from. Used as an explicit parent-owned eligibility gate:
 * a surface must set `dynamicCommissioningAtbSource` to one of these values
 * for `AddToBasketButton` to fire DC ATB analytics and update the active
 * commissioning U1/siteId pair. Surfaces that do not set it are descoped
 * by default (e.g. Bestsellers carousel, recommendations).
 *
 * Source: Eduardo Gutierrez (DC architecture owner), CSF-1851 review,
 * 2026-05-28 — replaces the implicit `!motomProductId` gate with explicit
 * source identity to keep telemetry-ready slicing without future migrations.
 */
export const CSF_DC_ATB_SOURCES = {
    PRODUCT_GRID: 'PRODUCT_GRID',
    POST_DETAILS: 'POST_DETAILS'
};
